import React from "react";
import { SpinnerLoading } from "../spinnerLoading";
import classnames from "classnames";
import styles from "./styles.css";

export class LoadingOverlay extends React.Component {
  render() {
    return (
      <div className={classnames(styles.loadingOverlayWrapper)}>
        <SpinnerLoading />

        Loading hairstyles
      </div>
    );
  }
}
